import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    lanugages : {},
    // selectedLangCodeForVoiceCammand: '',
    selectedLanguage : 'en',
    currentModule : '',
    moduleTrans : {} 
};

const languageSlice = createSlice({
    name:'language',
    initialState,
    reducers : {
        setLanguages : (state, {payload}) => {
            state.lanugages = payload;
        },
        setCurrentLanguage : (state, {payload}) => {
            state.selectedLanguage = payload;
        },
        setCurrentModule : (state, {payload}) => {
            state.currentModule = payload;
        },
        setModuleTrans : (state, {payload}) => {
            state.moduleTrans = payload;
        }
    }
})

export const {
    setLanguages, setCurrentLanguage, setCurrentModule, setModuleTrans
} = languageSlice.actions;

export const getLanguages = (state) => state.language.lanugages;

export const getSelectedLanguage = (state) => state.language.selectedLanguage;

export const getCurrentModule = (state) => state.language.currentModule;

export const getModuleTrans = (state) => state.language.moduleTrans;

export default languageSlice.reducer;